import { useState } from 'react';
import { Button, Modal, Box, CircularProgress, Typography, Grid, Autocomplete, Select, MenuItem, Checkbox, TextField } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { deepPurple } from '@mui/material/colors';
import { axiosInstance } from 'utils/axios';
import { successAlert, errorAlert, warningAlert } from 'ui-component/Toasts';
import { selectCurrentToken } from 'features/auth/authSlice';
import { useSelector } from 'react-redux';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const InsertAddressRecord = ({ cityNames }) => {
    const token = useSelector(selectCurrentToken);

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [fromAddressName, setfromAddressName] = useState('');
    const [toAddressName, settoAddressName] = useState('');
    const [fromCityName, setfromCityName] = useState('');
    const [toCityName, settoCityName] = useState('');
    const [amount, setamount] = useState(1);
    const [updateActive, setupdateActive] = useState(false);

    const [insertBtnDisabled, setInsertBtnDisabled] = useState(false);
    const [insertTasklistLoading, setInsertTasklistLoading] = useState(false);

    const insertAddress = async () => {
        setInsertBtnDisabled(true);
        setTimeout(() => {
            setInsertBtnDisabled(false);
        }, 3000);
        setInsertTasklistLoading(true);
        console.log("dist doesn't ran");
        try {
            const res = await axiosInstance.post(
                '/Address',
                {
                    fromAddressName: fromAddressName,
                    fromCityName: fromCityName,
                    toAddressName: toAddressName,
                    toCityName: toCityName,
                    active: updateActive,
                    amount: amount
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('Address Inserted successfully.');
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setInsertTasklistLoading(false);
        }
    };

    return (
        <>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: deepPurple[500],
                    color: 'white',
                    marginLeft: 'auto',
                    marginBottom: '20px',
                    marginRight: '20px'
                }}
            >
                Insert Address
            </Button>

            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                {insertTasklistLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box sx={style}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography id="modal-modal-title" variant="h3" component="h2">
                                Insert Address
                            </Typography>
                            <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                        </Box>
                        <Box
                            id="modal-modal-description"
                            sx={{
                                height: '450px',
                                overflowY: 'auto'
                            }}
                        >
                            <Grid item container xs={12} sx={{ mt: 2 }}>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            From Address Name :
                                        </Typography>
                                        <input
                                            type="text"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={fromAddressName}
                                            onChange={(e) => setfromAddressName(e.target.value)}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            To Address Name :
                                        </Typography>
                                        <input
                                            type="text"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={toAddressName}
                                            onChange={(e) => settoAddressName(e.target.value)}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            From City Name :
                                        </Typography>
                                        <Autocomplete
                                            freeSolo
                                            value={fromCityName}
                                            onChange={(event, newValue) => {
                                                setfromCityName(newValue);
                                            }}
                                            inputValue={fromCityName}
                                            onInputChange={(event, newInputValue) => {
                                                setfromCityName(newInputValue);
                                            }}
                                            id="controllable-states-demo"
                                            options={cityNames.map((city) => ({ label: city.name, value: city.id }))}
                                            sx={{ width: 170 }}
                                            renderInput={(params) => <TextField {...params} />}
                                            disableClearable
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            To City Name :
                                        </Typography>
                                        <Autocomplete
                                            freeSolo
                                            value={toCityName}
                                            onChange={(event, newValue) => {
                                                settoCityName(newValue);
                                            }}
                                            inputValue={toCityName}
                                            onInputChange={(event, newInputValue) => {
                                                settoCityName(newInputValue);
                                            }}
                                            id="controllable-states-demo"
                                            options={cityNames.map((city) => ({ label: city.name, value: city.id }))}
                                            sx={{ width: 170 }}
                                            renderInput={(params) => <TextField {...params} />}
                                            disableClearable
                                        />
                                    </Box>
                                </Grid>

                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Active :
                                        </Typography>
                                        <Checkbox
                                            checked={updateActive}
                                            onChange={(e) => setupdateActive(e.target.checked)} // Use checked value directly
                                        />
                                    </Box>
                                </Grid>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Amount :
                                        </Typography>
                                        <input
                                            type="number"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={amount}
                                            onChange={(e) => setamount(e.target.value)}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Button
                            variant="contained"
                            sx={{
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '50px'
                            }}
                            onClick={() => insertAddress()}
                            disabled={insertBtnDisabled}
                        >
                            Insert Address
                        </Button>
                    </Box>
                )}
            </Modal>
        </>
    );
};

export default InsertAddressRecord;
